import axios from 'axios';
import moment from 'moment';
export const FETCH_POSTS = 'FETCH_POSTS';
export const POST_TYPE = 'POST_TYPE';
export const FETCH_FEATURED = 'FETCH_FEATURED';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const CATEGORY_SOURCE = 'CATEGORY_SOURCE';
export const CATEGORY_FILTER = 'CATEGORY_FILTER';
export const TOGGLE_VIEW = 'TOGGLE_VIEW';
export const START_DATE = 'START_DATE';
export const END_DATE = 'END_DATE';
export const PER_PAGE = 'PER_PAGE';
export const PAGE_NUMBER = 'PAGE_NUMBER';
export const TOTAL_PAGES = 'TOTAL_PAGES';
export const TOTAL_RESULTS = 'TOTAL_RESULTS';
export const SEARCH_TERM = 'SEARCH_TERM';
export const LOADING = 'LOADING';

export function searchSite( searchTerm = '', catName = '', perPage = 12, pageNum = 1, startDate = '', endDate = '' ) {
	return ( dispatch, getState ) => {
		const { categories, postType } = getState();
		const customEndpoints = ['documents'];
		let params = `&search=${ searchTerm }`;
		let versionString = customEndpoints.includes( postType )
		                    ? wpApiSettings.isdaVersionString
		                    : wp.api.versionString;

		if ( '' !== catName && 'posts' === postType ) {
			const catTerm      = categories.find( cat => cat.slug === catName ),
			      children     = categories.filter( cat => cat.parent === catTerm.id )
			                                                                               .map( child => child.id ),
			      category_ids = (children.length
			                                                                     )
			                     ? `${ catTerm.id },${ children.join( ',' ) }`
			                     : catTerm.id;
			params += `&categories=${ category_ids }`;
		}

		const url = `${ wpApiSettings.root }${ versionString }${ postType }?_embed${ params }&per_page=${ perPage }&page=${ pageNum }`;
		let featuredRootUrl = `${ wpApiSettings.root }isda/v1/megamenu-search`;
		const featuredUrl = `${ featuredRootUrl }?_embed${ params }&per_page=${ perPage }&page=${ pageNum }`;
		let getSearch = function( url ) {
			return axios.get( url );
		};

		let featuredSearch = function( featuredUrl, pageNum ) {
			if ( 1 === pageNum && 'posts' === postType ) {
				return axios.get( featuredUrl );
			} else {
				return { data: [] };
			}
		};

		axios.all( [getSearch( url ), featuredSearch( featuredUrl, pageNum )] )
		     .then( axios.spread( function( postsResponse, featuredResponse ) {

			     //get featured post IDS
			     let featuredIDS = featuredResponse.data.map( post => post.id );
			     // filter featured IDS from posts results to prevent duplicated posts
			     let postsWithoutFeatured = postsResponse.data.filter( post => {
				     return !featuredIDS.includes( post.id );
			     } );
			     // merge featured with posts
			     let finalResults = featuredResponse.data.concat( postsWithoutFeatured );
			     dispatch( {
				               type: FETCH_POSTS, payload: finalResults
			               } );
			     dispatch( {
				               type   : TOTAL_PAGES,
				               payload: postsResponse.headers[ 'x-wp-totalpages' ]
			               } );
			     dispatch( {
				               type   : TOTAL_RESULTS,
				               payload: postsResponse.headers[ 'x-wp-total' ]
			               } );
		     } ) );
		/*axios.get(url).then(response => {
		 dispatch({
		 type: FETCH_POSTS, payload: response.data,
		 });
		 dispatch({
		 type: TOTAL_PAGES,
		 payload: response.headers['x-wp-totalpages'],
		 });
		 dispatch({
		 type: TOTAL_RESULTS,
		 payload: response.headers['x-wp-total'],
		 });
		 });*/
	};
}

export function fetchPosts(
	catName = '', perPage = 12, pageNum = 1, searchTerm = '', startDate = '',
	endDate = '', subCategories = '') {
	return (dispatch, getState) => {
		dispatch({
			type: LOADING, payload: true,
		});
		const {categories} = getState();
		if ('' !== catName && !categories.length) {
			dispatch({
				type: FETCH_POSTS, payload: [],
			});
		} else {
			const catTerm = categories.find(cat => cat.slug === catName),
				category_ids = catTerm.id;
			let allCategories = category_ids;
			if (subCategories.length !== 0) {
				allCategories = subCategories;
			} else if ( !String(allCategories).includes(',') ) {
				// Find child categories if single category
				const childCategories = ISDA_Main.categories
					.filter(cat => cat.parent === parseInt(allCategories))
					.map(cat => cat.cat_ID);
				
				if ( childCategories.length ) {
					allCategories = [allCategories, ...childCategories].join(',');
				}
			}

			const updatedStartDate = startDate instanceof Date ? moment(startDate) : (startDate === null ? '' : startDate);
			const updatedEndDate = endDate instanceof Date ? moment(endDate) : (endDate === null ? '' : endDate);
			let apiParams = '';
			
			if ( '' !== catName && '' === catTerm.external_url ) {
				apiParams += `&categories=${allCategories}`;
			}

			apiParams += ('' !== searchTerm
			) ? `&search=${searchTerm}` : '';
			apiParams += ('object' === typeof updatedStartDate &&
			              ('Moment' === updatedStartDate.constructor.name || updatedStartDate._isAMomentObject === true)
			)
				? `&after=${updatedStartDate.format('YYYY-MM-DDTHH:mm:ss')}`
				: '';
			apiParams += ('object' === typeof updatedEndDate &&
			              ('Moment' === updatedEndDate.constructor.name  || updatedEndDate._isAMomentObject === true)
			)
				? `&before=${updatedEndDate.format('YYYY-MM-DDTHH:mm:ss')}`
				: '';
			let rootUrl = '' !== catTerm.external_url
			              ? `${ catTerm.external_url }`
			              : `${ wpApiSettings.root }${ wp.api.versionString }posts`;
			const url = `${ rootUrl }?_embed${ apiParams }&per_page=${ perPage }&page=${ pageNum }`;

			axios.get( url ).then( response => {
				dispatch( {
					          type: FETCH_POSTS, payload: response.data
				          } );
				dispatch( {
					          type   : TOTAL_PAGES,
					          payload: response.headers[ 'x-wp-totalpages' ]
				          } );
				dispatch( {
					          type   : TOTAL_RESULTS,
					          payload: response.headers[ 'x-wp-total' ]
				          } );
				if ( '' === catTerm.external_url ) {
					dispatch( {
						          type: CATEGORY_SOURCE, payload: 'local'
					          } );
				} else {
					dispatch( {
						          type: CATEGORY_SOURCE, payload: 'external'
					          } );
				}
			}).finally(() => {
				dispatch({
					type: LOADING, payload: false,
				});
			});
		}
	};
}

export function fetchFeatured( slug = '' ) {
	return ( dispatch ) => {
		const url = `${ wpApiSettings.root }isda/v1/featured?slug=${ slug }`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_FEATURED, payload: response.data
			          } );
		} );
	};
}

export function fetchMultipleFeatured( categorieSlugs = [] ) {
	return ( dispatch ) => {
		let allFeaturedData = [];
		let fetchPromises = categorieSlugs.map( slug => {
			const url = `${ wpApiSettings.root }isda/v1/featured?slug=${ slug }`;
			return axios.get( url ).then( response => {
				allFeaturedData.push( ...response.data );
			} );
		} );

		Promise.all( fetchPromises ).then( () => {
			dispatch( {
				          type: FETCH_FEATURED, payload: allFeaturedData
			          } );
		} );
	};
}

export function fetchCategories() {
	return ( dispatch ) => {
		axios.get( `${ wpApiSettings.root }${ wp.api.versionString }categories?per_page=100` )
		     .then( response => {
			     dispatch( {
				               type: FETCH_CATEGORIES, payload: response.data
			               } );
		     } );
	};
}

export function setPage( pageNum ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: PAGE_NUMBER, payload: pageNum
		          } );
		dispatch( {
			          type: FETCH_POSTS, payload: []
		          } );
	};
}

export function categoryfilter( category ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: CATEGORY_FILTER, payload: category
		          } );
		dispatch( {
			          type: FETCH_POSTS, payload: []
		          } );
	};
}

export function triggerSearch( searchTerm ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SEARCH_TERM, payload: searchTerm
		          } );
	};
}

export function clearSearchTerm() {
	return (dispatch) => {
		dispatch({
			type: SEARCH_TERM, payload: '',
		});
	};
}

export function changePostType( postType ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: POST_TYPE, payload: postType
		          } );
		dispatch( {
			          type: PAGE_NUMBER, payload: 1
		          } );
		dispatch( {
			          type: FETCH_POSTS, payload: []
		          } );
	};
}

export function getPageNum() {
	return ( dispatch ) => {
		const queryString = window.location.search,
		      urlParams   = new URLSearchParams( queryString );

		let pageNum = urlParams.get( 'page' );

		if(pageNum === null){
			pageNum = 1;
		}

		return pageNum;
	};
}